import client from "@irati/utils/services/apollo"
import {Recognition, Poll, RecognitionSource} from "@irati/types"
import PBService from "@irati/utils/services"
import rewardErrorHandler from "@irati/reward/services/errors/rewardErrorHandler"

import getRecognitionQuery from "./queries/Recognition"
import createRecognitionMutation from "./mutations/CreateRecognition"
import updatePollWithRewardIdMutation from "./mutations/UpdatePollWithReward"
import updateRecognitionWithRewardIdMutation from "./mutations/UpdateRecognitionWithRewardId"
import updateRecognitionWithRewardMutation from "./mutations/UpdateRecognitionWithReward"
import recognitionErrorHandler from "./errors/recognitionErrorHandler"

interface RecognitionPayload {
  message: string
  source: RecognitionSource
  walletTransferId?: string
  teamIds?: string[]
  userIds?: string[]
  expectReward?: boolean
  isPrivate?: boolean
  companyValues?: string[]
  occasionId?: string
}

class RecognitionService extends PBService {
  get(id: string): Promise<Recognition> {
    return client.query({query: getRecognitionQuery, variables: {id}}).then(({data}) => {
      return data.recognition
    })
  }

  create(recognition: Partial<RecognitionPayload>): Promise<Recognition> {
    return client.mutate({mutation: createRecognitionMutation, variables: {recognition}}).then(({data}) => {
      return data.createRecognition
    })
  }

  updateRecognitionWithReward(recognitionId: string, walletTransferId: string): Promise<Recognition> {
    return client.mutate({mutation: updateRecognitionWithRewardMutation, variables: {recognitionId, walletTransferId}}).then(({data}) => {
      return data.updateRecognitionWithRewardMutation
    })
  }

  updateRecognitionWithRewardId(recognitionId: string, orderId: string): Promise<Recognition> {
    return client.mutate({mutation: updateRecognitionWithRewardIdMutation, variables: {recognitionId, orderId}}).then(({data}) => {
      return data.updateRecognitionWithRewardId
    })
  }

  updatePollWithRewardId(pollId: string, orderId: string): Promise<Poll> {
    return client.mutate({mutation: updatePollWithRewardIdMutation, variables: {pollId, orderId}}).then(({data}) => {
      return data.updatePollWithRewardId
    })
  }
}

const service = new RecognitionService({errorHandlers: [recognitionErrorHandler, rewardErrorHandler]})

export default service
